import { render } from "./FilaCongelamentoPlanilhas.vue?vue&type=template&id=25570c66&scoped=true"
import script from "./FilaCongelamentoPlanilhas.vue?vue&type=script&lang=js"
export * from "./FilaCongelamentoPlanilhas.vue?vue&type=script&lang=js"

import "./FilaCongelamentoPlanilhas.vue?vue&type=style&index=0&id=25570c66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25570c66"]])

export default __exports__